module.exports = __webpack_public_path__ + "img/t.19c0c877.svg";